/**
 * TEK SEFERLİK "İKİ KARE SONRA" — çark dönüşünün ilk karesindeki hıçkırığı gidermek için (Emre/koordinatör 07.10).
 *
 * ================================================================
 * NEDEN VAR
 * ================================================================
 * ÇEVİR'e basılınca aynı kareye üç iş birden biniyordu: 32 ampulün animasyon süresi değişiyor (hepsi yeniden
 * başlıyor), dil titremeye başlıyor ve çark katmanının dönüş geçişi başlıyor. 6× CPU kısmasında bu tek karede
 * 117 ms'ye varan bir takılma ölçüldü (sürekli animasyonlar sabit 16,7 ms'ydi). Çözüm: önce ampul ve dil
 * durumu çizilir (boyanır), dönüş BİR SONRAKİ karede başlar — iş iki kareye yayılır.
 *
 * Bu bir kare DÖNGÜSÜ değildir (çocuk güvenliği bekçisi `Cark.tsx` kaynağında `requestAnimationFrame` yasaklar):
 * tek seferlik, iptal edilebilir ve yalnız bu dosyada. `requestAnimationFrame` yoksa (test ortamı, eski
 * tarayıcı) bir sonraki görev turuna düşer.
 */
export function ikiKareSonra(is: () => void): () => void {
  if (typeof requestAnimationFrame !== "function") {
    const zaman = setTimeout(is, 0);
    return () => clearTimeout(zaman);
  }
  let ikinci = 0;
  const birinci = requestAnimationFrame(() => {
    ikinci = requestAnimationFrame(is);
  });
  return () => {
    cancelAnimationFrame(birinci);
    if (ikinci !== 0) cancelAnimationFrame(ikinci);
  };
}
